import DarkMode from "./themes/DarkMode";
import AccentColor from "./themes/AccentColor";
import ShipAddy from './ShipAddy';
import "../styles/Settings.css";


function Settings() {
  return (
    <div className="bounds">
      <div className="grid-100">
        <ShipAddy />
        <DarkMode />
        <AccentColor />

      </div>
    </div>
  );
}

export default Settings;